import { useCallback, useState } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { CREDIT_MEMO_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CreditMemosEditorIframeModal, useCreditMemoEditor } from 'credit-memos-iframe-lib';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreditMemoChickletPrimaryDisplayLabelRedesign = ({
  canView,
  properties,
  primaryDisplayProperty,
  toObjectId
}) => {
  const displayValue = (primaryDisplayProperty === null || primaryDisplayProperty === void 0 ? void 0 : primaryDisplayProperty.value) || DISPLAY_LABEL_FALLBACK;
  const status = getPropertyValueFromProperties(properties, 'hs_credit_memo_status');
  const creditMemoUrl = getPropertyValueFromProperties(properties, 'hs_credit_memo_url') || undefined;
  const isDraft = status === 'draft';
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const {
    handleCreditMemoEditorClose
  } = useCreditMemoEditor(setIsEditorOpen, toObjectId ? Number(toObjectId) : null);
  const openCreditMemoEditor = useCallback(() => {
    setIsEditorOpen(true);
  }, []);
  if (!canView) {
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "credit-memo-chicklet-title",
      children: displayValue
    });
  }
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "credit-memo-chicklet-title",
    children: !isDraft ? /*#__PURE__*/_jsx(Link, {
      href: creditMemoUrl,
      external: true,
      truncate: true,
      "data-test-id": "credit-memo-chicklet-external-link",
      children: displayValue
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Link, {
        onClick: openCreditMemoEditor,
        "data-test-id": "credit-memo-chicklet-edit-link",
        truncate: true,
        children: displayValue
      }), isEditorOpen && toObjectId && /*#__PURE__*/_jsx(CreditMemosEditorIframeModal, {
        show: isEditorOpen
        // @ts-expect-error Using string literal for operation instead of importing enum
        ,
        operation: "EDIT",
        objectId: String(toObjectId),
        objectTypeId: CREDIT_MEMO_TYPE_ID,
        onClose: handleCreditMemoEditorClose
      })]
    })
  });
};
export default CreditMemoChickletPrimaryDisplayLabelRedesign;